const ORIGINS = ["linkedin.com", "greenhouse.io"];

export const isExtension = () => {
  const origins = Array.from(window.location.ancestorOrigins);
  return (
    origins.some((o) => o.startsWith("chrome-extension")) &&
    origins.every((o) => !ORIGINS.every((origin) => !o.includes(origin)))
  );
};

export const isExtensionOrPopup = () => {
  const origins = Array.from(window.location.ancestorOrigins);
  return (
    origins.some((o) => o.startsWith("chrome-extension")) &&
    origins.some((o) => ORIGINS.some((origin) => o.includes(origin)))
  );
};
